

function findResult(arr, parent = null, scode) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].scode == scode) {
            return parent
        }
        if (arr[i].subs && arr[i].subs.length) {
            return findResult(arr[i].subs, arr[i], scode)
        }
    }
}
export function filterResultscode(arr, scode) {

    let reuslt = null
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].scode == scode) {
            reuslt = arr[i]
            break
        }
    }
    if (!reuslt) {
        reuslt = findResult(arr, null, scode)
    }

    return reuslt
}

//获取某个节点的所有父节点
export function getTreeIds(list, scode) {
    for (let i = 0; i < list.length; i++) {
        if (list[i].scode == scode) {
            //查询到返回该数组对象
            return [list[i]];
        }
        if (list[i].subs && list[i].subs.length) {
            let node = getTreeIds(list[i].subs, scode);
            if (node !== undefined) {
                //查询到把父节点连起来
                return node.concat(list[i]);
            }
        }
    }
}






// WEBPACK FOOTER //
// ./src/libs/utils.js